import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import "../../components/modals/show-document/show-doc.scss";
import { getMerchantStatement } from "../../api";

function ShowMerchantStatement(props) {
    const [isLoading, setLoading] = useState(true);
    const [pdf, setPdf] = useState("");

    useEffect(() => {
        getMerchantStatement({
            powerapp_id: props.powerappId,
            year: props.year,
            month: props.month,
        }).then((res) => {
            if (res.status) {
                setPdf(res.data);
                setLoading(false);
            }
        });
    }, []);

    return (
        <div>
            <Modal isOpen={props.open} className="doc-modal">
                <div className="header dFlex">
                    <h5>
                        File : Merchant_Statement_{props.year}_{props.month}.PDF
                    </h5>
                    <div className="opn-btn">
                        <a
                            className="download-link"
                            download={`Merchant_Statement_${props.year}_${props.month}.PDF`}
                            href={"data:application/pdf;base64," + pdf}
                        >
                            {" "}
                            <i className="fa fa-download pointer"></i>{" "}
                        </a>
                        <button
                            className="close-modal"
                            onClick={() => props.close()}
                        >
                            {" "}
                            <i className="fa fa-times pointer"></i>
                        </button>
                    </div>
                </div>
                {isLoading ? (
                    <p className="loader"></p>
                ) : (
                    <embed
                        src={"data:application/pdf;base64," + pdf}
                        className="file-src"
                    />
                )}
            </Modal>
        </div>
    );
}

export default ShowMerchantStatement;
